const UserInteractions = {
  SeenChatbot: 'isChatbotSeen',
  isOnboardingPassed: 'isOnboardingPassed',
};

module.exports = UserInteractions;
